import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { passengersFormsSelector } from '@/models/forms/selectors';
import { MIN } from '@/libs/constants';
const PRICE_PER_PASSENGER = 700;
const CACHE_TIME = MIN;
const calculateInsurancePrice = async (passengersCount) => {
    return passengersCount * PRICE_PER_PASSENGER;
};
export const useInsurancePrice = () => {
    const passengers = useSelector(passengersFormsSelector);
    const passengersCount = passengers.length;
    const { data: price, isLoading, error, } = useQuery(['insurance-price', passengersCount], () => calculateInsurancePrice(passengersCount), {
        staleTime: CACHE_TIME,
        cacheTime: CACHE_TIME,
        refetchOnWindowFocus: false,
        enabled: passengersCount > 0,
    });
    return {
        price: price ?? 0,
        isLoading,
        error,
    };
};
